import { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import type { StepState } from '@/lib/setupSteps';
import { StepHeader } from './SetupStep';

interface CollapsibleSetupStepProps {
  index: number;
  state: StepState;
  title: string;
  description: string;
  defaultOpen?: boolean;
  children?: React.ReactNode;
}

const CollapsibleSetupStep: React.FC<CollapsibleSetupStepProps> = ({
  index,
  state,
  title,
  description,
  defaultOpen = false,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Collapsible
      open={open}
      onOpenChange={setOpen}
      className="border-b border-border last:border-b-0"
    >
      <CollapsibleTrigger className="flex w-full gap-3 p-5 text-left hover:bg-muted/40">
        <StepHeader index={index} state={state} title={title} description={description} />
        <ChevronDown
          className={`h-5 w-5 flex-none text-muted-foreground transition-transform ${open ? 'rotate-180' : ''}`}
        />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="space-y-3 px-5 pb-5 pl-14">{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default CollapsibleSetupStep;
